export enum EVENTS {
    /**
     * @value Add a note to the notification to explain your changes
     * @description Helper explaining why the user updated the event
     */
    ADD_NOTE = 'EVENTS.ADD_NOTE',
    /**
     * @value Ask to attend
     */
    ASK_TO_ATTEND = 'EVENTS.ASK_TO_ATTEND',
    /**
     * @value Your request has been sent and need an approval from an organizer
     */
    ASK_TO_ATTEND_SUCCESS_MESSAGE = 'EVENTS.ASK_TO_ATTEND_SUCCESS_MESSAGE',
    /**
     * @value Attend
     */
    ATTEND = 'EVENTS.EVENT_BUTTON.ATTEND',
    /**
     * @value Attendance list
     */
    ATTENDANCE_LIST = 'EVENTS.EVENT_ATTENDANCE_LIST',
    /**
     * @value Attendees
     */
    ATTENDEES = 'FRONT.WIDGET_EVENT_METADATA.ATTENDEES',
    /**
     * @value Failed to notify attendees
     * @description The message displayed when we failed to notify the users who are attending an event.
     */
    ATTENDEES_NOTIFICATION_ERROR = 'EVENTS.ATTENDEES_NOTIFICATION_ERROR',
    /**
     * @value Attendees notified
     * @description The message displayed when we succeed to notify the users who are attending an event.
     */
    ATTENDEES_NOTIFICATION_SUCCESS = 'EVENTS.ATTENDEES_NOTIFICATION_SUCCESS',
    /**
     * @value Copy event link
     * @description Options to copy the link to the event page in the clipboard of the user
     */
    COPY_LINK = 'EVENTS.COPY_LINK',
    /**
     * @value Create an event
     * @description Text displayed on a button to redirect an user to the creation of an event
     */
    CREATE_EVENT = 'EVENTS.CREATE_EVENT',
    /**
     * @value Event deleted
     * @description - Placeholder in a post indicating the event has been deleted
     * - One of the notification types in user Settings
     */
    DELETED = 'EVENTS.DELETED',
    /**
     * @value Keep it
     * @description Button to cancel the deletion of an event
     */
    DELETE_CONFIRM_DIALOG_CANCEL = 'FRONT.EVENTS.DELETE.CONFIRM_DIALOG.CANCEL',
    /**
     * @value The event will be deleted permanently. This action can’t be reverted.
     * @description Event deletion confirm dialog description
     */
    DELETE_CONFIRM_DIALOG_DESCRIPTION = 'FRONT.EVENTS.DELETE.CONFIRM_DIALOG.DESCRIPTION',
    /**
     * TODO: rename as "DELETE_EVENT"?
     * @value Delete event
     * @description Button to confirm the deletion of an event
     */
    DELETE_CONFIRM_DIALOG_OK = 'FRONT.EVENTS.DELETE.CONFIRM_DIALOG.OK',
    /**
     * TODO: rename as "DELETE_EVENT" ?
     * @value Delete event
     * @description Event deletion confirm dialog title
     */
    DELETE_CONFIRM_DIALOG_TITLE = 'FRONT.EVENTS.DELETE.CONFIRM_DIALOG.TITLE',
    /**
     * @value Delete event
     * @description A label for a button aiming to delete an event.
     */
    DELETE_EVENT = 'FRONT.EVENT.DIALOG.DELETE_EVENT',
    /**
     * @value Event successfully deleted
     * @description Message when an event has been successfully deleted
     */
    DELETE_SUCCESS_NOTIFICATION = 'FRONT.EVENTS.DELETE.SUCCESS_NOTIFICATION',
    /**
     * @value Limit the number of attendees
     * @description Text used to set a limited numbers of attendees on an event
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES',
    /**
     * @value %NB% users are already registered
     * @description Error displayed on event limited attendees when the user enter a capacity value lower than the attendees already registrated.
     * Exemple: 2 users are already registered
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_CAPACITY_ERROR = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_CAPACITY_ERROR',
    /**
     * @value By default, organizers are not included in this limit. If you create an event, and later decide to set the max number of attendees, you cannot set the limit below the number of already registered attendees (%NB%).
     * @description Text used to explain how the attendees capacity works on edition
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_HELPER = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_HELPER',
    /**
     * @value When the limit is reached non-attendees cannot attend the event. Organizers are not included in this limit.
     * @description Text used to explain how the attendees capacity works on creation
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_HELPER_WITHOUT_NB = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_HELPER_WITHOUT_NB',
    /**
     * @value Maximum number of attendees
     * @description Text used as a label of the event capacity input
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_LABEL = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_LABEL',
    /**
     * @value Add at least one person
     * @description Error displayed on event capacity when user try to set the capacity to 0
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_MIN_CAPACITY_ERROR = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_MIN_CAPACITY_ERROR',
    /**
     * @value Add a number of users (minimum is %NB%)
     * @description Text used as a placeholder of the event edition capacity input
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_PLACEHOLDER = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_PLACEHOLDER',
    /**
     * @value Add a number of users
     * @description Text used as a placeholder of the event creation capacity input
     */
    DIALOG_CAPACITY_LIMITED_ATTENDEES_PLACEHOLDER_WITHOUT_NB = 'EVENTS.DIALOG_CAPACITY_LIMITED_ATTENDEES_PLACEHOLDER_WITHOUT_NB',
    /**
     * @value Registrations on request
     */
    DIALOG_CAPACITY_REGISTER_ATTENDEES = 'EVENTS.DIALOG_CAPACITY_REGISTER_ATTENDEES',
    /**
     * @value Organizers and trainers are not counted in this limit. If you set a maximum number of attendees after creating an event, you cannot set the limit below the number of attendees already registered.
     */
    DIALOG_CAPACITY_REGISTER_ATTENDEES_HELPER = 'EVENTS.DIALOG_CAPACITY_REGISTER_ATTENDEES_HELPER',
    /**
     * @value Limit number of attendees
     */
    DIALOG_CAPACITY_REGISTER_ATTENDEES_LABEL = 'EVENTS.DIALOG_CAPACITY_REGISTER_ATTENDEES_LABEL',
    /**
     * @value Users can request to participate, and organizers can approve or deny these requests.
     */
    DIALOG_CAPACITY_REGISTER_ATTENDEES_LABEL_HELPER = 'EVENTS.DIALOG_CAPACITY_REGISTER_ATTENDEES_LABEL_HELPER',
    /**
     * @value Unlimited if empty
     */
    DIALOG_CAPACITY_REGISTER_ATTENDEES_PLACEHOLDER = 'EVENTS.DIALOG_CAPACITY_REGISTER_ATTENDEES_PLACEHOLDER',
    /**
     * @value Unlimited attendees
     * @description Text used to set an unlimited numbers of attendees on an event
     */
    DIALOG_CAPACITY_UNLIMITED_ATTENDEES = 'EVENTS.DIALOG_CAPACITY_UNLIMITED_ATTENDEES',
    /**
     * @value Write description here.
     */
    DIALOG_CONTENT_PLACEHOLDER = 'FRONT.EVENT.DIALOG.CONTENT_PLACEHOLDER',
    /**
     * @value Ending day
     */
    DIALOG_ENDING_DAY = 'FRONT.EVENT.DIALOG.ENDING_DAY',
    /**
     * @value Ending hour
     */
    DIALOG_ENDING_HOUR = 'FRONT.EVENT.DIALOG.ENDING_HOUR',
    /**
     * @value Hide people list
     */
    DIALOG_HIDE_PEOPLE_LIST = 'EVENTS.DIALOG.HIDE_PEOPLE_LIST',
    /**
     * @value Only organizers will be able to see the list of attendees
     */
    DIALOG_HIDE_PEOPLE_LIST_HELPER = 'EVENTS.DIALOG.HIDE_PEOPLE_LIST_HELPER',
    /**
     * @value Text to display
     */
    DIALOG_LINK_LABEL = 'FRONT.EVENT.DIALOG.LINK_LABEL',
    /**
     * @value Select an option
     */
    DIALOG_LINK_LABEL_PLACEHOLDER = 'FRONT.EVENT.DIALOG.LINK_LABEL_PLACEHOLDER',
    /**
     * @value Location
     */
    DIALOG_LOCATION_LABEL = 'FRONT.EVENT.DIALOG.LOCATION_LABEL',
    /**
     * @value Venue, address
     */
    DIALOG_LOCATION_PLACEHOLDER = 'FRONT.EVENT.DIALOG.LOCATION_PLACEHOLDER',
    /**
     * @value The "Attend" option is unavailable. Users cannot register.
     * @description Text used on the event edition, as an helper of an option to hide attendees capabilities of an event.
     */
    DIALOG_NO_ATTENDEES_HELPER = 'EVENTS.DIALOG_NO_ATTENDEES_HELPER',
    /**
     * @value No attendees
     * @description Text used on the event edition, as a label of an option to hide attendees capabilities of an event.
     */
    DIALOG_NO_ATTENDEES_LABEL = 'EVENTS.DIALOG_NO_ATTENDEES_LABEL',
    /**
     * @value Organizers
     */
    DIALOG_ORGANIZERS = 'FRONT.EVENT.DIALOG.ORGANIZERS',
    /**
     * @value Organizers can edit the event.
     */
    DIALOG_ORGANIZERS_INFO = 'FRONT.EVENT.DIALOG.ORGANIZERS_INFO',
    /**
     * @value Starting day
     */
    DIALOG_STARTING_DAY = 'FRONT.EVENT.DIALOG.STARTING_DAY',
    /**
     * @value Starting hour
     */
    DIALOG_STARTING_HOUR = 'FRONT.EVENT.DIALOG.STARTING_HOUR',
    /**
     * @value Event title
     */
    DIALOG_TITLE_PLACEHOLDER = 'FRONT.EVENT.DIALOG.TITLE_PLACEHOLDER',
    /**
     * @value Add event image
     * @description Add featured image to an event
     */
    DIALOG_TITLE_UPLOADER = 'FRONT.EVENT.DIALOG.TITLE_UPLOADER',
    /**
     * @value Download people list
     */
    DOWNLOAD_PEOPLE_LIST = 'WIDGET_EVENT_METADATA.DOWNLOAD_PEOPLE_LIST',
    /**
     * @value Don’t send
     */
    DO_NOT_SEND_INVITATION = 'EVENTS.DO_NOT_SEND_INVITATION',
    /**
     * @value Duration (h)
     */
    DURATION_HOURS = 'EVENTS.DURATION_HOURS',
    /**
     * @value Duration (mn)
     */
    DURATION_MINUTES = 'EVENTS.DURATION_MINUTES',
    /**
     * @value Edit event
     */
    EDIT_EVENT = 'FRONT.EVENT.DIALOG.EDIT_EVENT',
    /**
     * @value This section gives you access to events
     * @description Text displayed as a description when a list of events is empty without filter applied
     */
    EMPTY_STATE_DESCRIPTION = 'EVENTS.EMPTY_STATE_DESCRIPTION',
    /**
     * @value There are no events yet
     * @description Text displayed when no events have been created, when an user want to have the list of events without filters.
     */
    EMPTY_STATE_TITLE = 'EVENTS.EMPTY_STATE_TITLE',
    /**
     * @value Event analytics
     * @description Label of the button opening the event analytics dialog
     */
    EVENT_ANALYTICS = 'EVENTS.EVENT_ANALYTICS',
    /**
     * @value All events
     * @description Text used to filter the events in the event list widget.
     */
    FILTERING_ALL_EVENTS = 'EVENTS.FILTERING_ALL_EVENTS',
    /**
     * @value Coming events only
     * @description Text used to filter the events in the event list widget.
     */
    FILTERING_FUTURE_EVENTS = 'EVENTS.FILTERING_FUTURE_EVENTS',
    /**
     * @value Ongoing and coming events
     * @description Text used to filter the events in the event list widget for ongoing and future events.
     */
    FILTERING_ONGOING_AND_FUTURE_EVENTS = 'EVENTS.FILTERING_ONGOING_AND_FUTURE_EVENTS',
    /**
     * @value Ongoing events only
     * @description Text used to filter the events in the event list widget for ongoing events.
     */
    FILTERING_ONGOING_EVENTS = 'EVENTS.FILTERING_ONGOING_EVENTS',
    /**
     * @value Past and ongoing events
     * @description Text used to filter the events in the event list widget for past and ongoing events.
     */
    FILTERING_PAST_AND_ONGOING_EVENTS = 'EVENTS.FILTERING_PAST_AND_ONGOING_EVENTS',
    /**
     * @value Past events only
     * @description Text used to filter the events in the event list widget for past events
     */
    FILTERING_PAST_EVENTS = 'EVENTS.FILTERING_PAST_EVENTS',
    /**
     * @value No events match your search. Please try another entry.
     * @description Text displayed when the user apply filters to an event list and no events match this filters.
     */
    FILTERS_NO_RESULTS = 'EVENTS.FILTERS_NO_RESULTS',
    /**
     * @value Going
     */
    GOING = 'EVENTS.EVENT_BUTTON.GOING',
    /**
     * @value %NB% people
     */
    GUEST_LIST_LABEL = 'EVENTS.GUEST_LIST_LABEL',
    /**
     * @value Incorrect time format
     */
    INCORRECT_TIME_FORMAT = 'EVENTS.INCORRECT_TIME_FORMAT',
    /**
     * @value Please insert a number between 0 and 99.
     */
    INSERT_NUMBER_UNDER_99_ERROR = 'EVENTS.INSERT_NUMBER_UNDER_99_ERROR',
    /**
     * @value Already added
     */
    INVITATION_DIALOG_ALREADY_ADDED_GUEST = 'EVENTS.INVITATION_DIALOG_ALREADY_ADDED_GUEST',
    /**
     * @value People going to the event and invited people will be aware of the event modification
     */
    INVITATION_DIALOG_CONTENT_DESCRIPTION = 'EVENTS.INVITATION_DIALOG_CONTENT_DESCRIPTION',
    /**
     * @value Users will be notified of your event
     */
    INVITATION_DIALOG_EMPTY_DESCRIPTION = 'EVENTS.INVITATION_DIALOG_EMPTY_DESCRIPTION',
    /**
     * @value Invite users to your event
     */
    INVITATION_DIALOG_EMPTY_TITLE = 'EVENTS.INVITATION_DIALOG_EMPTY_TITLE',
    /**
     * @value Add people
     */
    INVITATION_DIALOG_SEARCH_FIELD_LABEL = 'EVENTS.INVITATION_DIALOG_SEARCH_FIELD_LABEL',
    /**
     * @value Search and add people
     */
    INVITATION_DIALOG_SEARCH_FIELD_PLACEHOLDER = 'EVENTS.INVITATION_DIALOG_SEARCH_FIELD_PLACEHOLDER',
    /**
     * @value Add at least one person
     */
    INVITATION_DIALOG_SEND_TOOLTIP = 'EVENTS.INVITATION_DIALOG_SEND_TOOLTIP',
    /**
     * @value Send invitations
     */
    INVITATION_DIALOG_TITLE = 'EVENTS.INVITATION_DIALOG_TITLE',
    /**
     * @value Manage requests
     */
    MANAGE_REQUESTS = 'EVENT.MANAGE_REQUESTS',
    /**
     * @value Not sure
     */
    MAYBE = 'EVENTS.EVENT_BUTTON.MAYBE',
    /**
     * TODO: rename key to remove mention of the dialog?
     * @value New event
     */
    NEW_EVENT = 'FRONT.EVENT.DIALOG.NEW_EVENT',
    /**
     * @value Notify people of event update
     */
    NOTIFICATION_DIALOG_CONTENT_TITLE = 'EVENTS.NOTIFICATION_DIALOG_CONTENT_TITLE',
    /**
     * @value Send notification
     */
    NOTIFICATION_DIALOG_TITLE = 'EVENTS.NOTIFICATION_DIALOG_TITLE',
    /**
     * @value Not going
     */
    NOT_GOING = 'EVENTS.EVENT_BUTTON.NOT_GOING',
    /**
     * @value Users who answered “going” will be listed here.
     */
    NO_GOING_PEOPLE_DESCRIPTION = 'WIDGET_EVENT_METADATA.NO_GOING_PEOPLE_DESCRIPTION',
    /**
     * @value No longer participate
     */
    NO_LONGER_PARTICIPATE = 'FRONT.EVENT_BUTTON.NO_LONGER_PARTICIPATE',
    /**
     * @value Users who answered “not sure” will be listed here.
     */
    NO_MAYBE_PEOPLE_DESCRIPTION = 'WIDGET_EVENT_METADATA.NO_MAYBE_PEOPLE_DESCRIPTION',
    /**
     * @value Users who answered “not going” will be listed here.
     */
    NO_NOT_GOING_PEOPLE_DESCRIPTION = 'WIDGET_EVENT_METADATA.NO_NOT_GOING_PEOPLE_DESCRIPTION',
    /**
     * @value There are no users
     */
    NO_PEOPLE_TITLE = 'WIDGET_EVENT_METADATA.NO_PEOPLE_TITLE',
    /**
     * @value Users who did not answered will be listed here.
     */
    NO_UNANSWERED_PEOPLE_DESCRIPTION = 'WIDGET_EVENT_METADATA.NO_UNANSWERED_PEOPLE_DESCRIPTION',
    /**
     * @value Open event details: %URL%
     */
    OPEN_EVENT_DETAILS = 'EVENTS.OPEN_EVENT_DETAILS',
    /**
     * @value Original link
     */
    ORIGINAL_LINK_LABEL = 'FRONT.EVENT.DIALOG.ORIGINAL_LINK_LABEL',
    /**
     * @value Participate
     */
    PARTICIPATE = 'FRONT.EVENT_BUTTON.PARTICIPATE',
    /**
     * @value {"one":"%ATTENDEES% going","other":"%ATTENDEES% going"}
     */
    PEOPLE_NUMBER = 'WIDGET_EVENT_METADATA.PEOPLE_NUMBER',
    /**
     * @value Published an event
     * @description Text describing that an event has been published.
     */
    PUBLISHED_AN_EVENT = 'STREAMS.PUBLISHED_AN_EVENT',
    /**
     * @value Published an event in %CONTAINER%
     * @description Text describing that an event has been published in the given container.
     */
    PUBLISHED_AN_EVENT_IN_CONTAINER = 'STREAMS.PUBLISHED_AN_EVENT_IN_CONTAINER',
    /**
     * @value Replay
     */
    RECORDING_LABEL = 'FRONT.EVENT.DIALOG.RECORDING_LABEL',
    /**
     * @value Register
     */
    REGISTER = 'FRONT.EVENT_BUTTON.REGISTER',
    /**
     * @value Registered
     */
    REGISTERED = 'FRONT.EVENT_BUTTON.REGISTERED',
    /**
     * @value Fully booked
     * @description Text displayed on the registration event button when the event is fully booked
     */
    REGISTRATION_FULLY_BOOKED = 'EVENTS.REGISTRATION_FULLY_BOOKED',
    /**
     * @value Event fully booked
     * @description Tooltip displayed when a user hover a registration status (like going) on a full event
     */
    REGISTRATION_FULLY_BOOKED_TOOLTIP = 'EVENTS.REGISTRATION_FULLY_BOOKED_TOOLTIP',
    /**
     * @value Register
     */
    REGISTRATION_LABEL = 'FRONT.EVENT.DIALOG.REGISTRATION_LABEL',
    /**
     * @value Spot has not been booked yet
     * @description Text displayed in a toast when a user select maybe of an event with defined capacity, therefore his spot is not booked
     */
    REGISTRATION_NOT_BOOKED_SPOT_WARNING = 'EVENTS.REGISTRATION_NOT_BOOKED_SPOT_WARNING',
    /**
     * @value No spot left
     */
    REGISTRATION_NO_SPOT_LEFT = 'EVENTS.REGISTRATION_NO_SPOT_LEFT',
    /**
     * @value {"one":"%NB% spot left","other":"%NB% spots left"}
     * @description Indicate the remaining spot available to attend to an event
     */
    REGISTRATION_SPOT_LEFT = 'EVENTS.REGISTRATION_SPOT_LEFT',
    /**
     * @value Spot has been vacated
     * @description Text displayed in a toast when a going user of an event select not going or maybe, therefore leaving his reserved spot
     */
    REGISTRATION_VACATED_SPOT_WARNING = 'EVENTS.REGISTRATION_VACATED_SPOT_WARNING',
    /**
     * @value Time is required
     */
    REQUIRED_TIME = 'EVENTS.REQUIRED_TIME',
    /**
     * @value Search for an event
     * @description The placeholder on the event list search filter
     */
    SEARCH_FOR_EVENT = 'EVENTS.SEARCH_FOR_EVENT',
    /**
     * @value {"one":"%COUNT% event selected","other":"%COUNT% events selected"}
     */
    SELECTED_EVENTS_COUNT = 'EVENTS.SELECTED_EVENTS_COUNT',
    /**
     * @value Select events
     * @description Text used on a button of the widget event list settings to select specific events.
     */
    SELECT_EVENTS = 'EVENTS.SELECT_EVENTS',
    /**
     * @value Send invitations
     */
    SEND_INVITATION = 'EVENTS.SEND_INVITATION',
    /**
     * @value Invitation sent
     */
    SEND_INVITATION_SUCCESS_NOTIFICATION = 'EVENTS.SEND_INVITATION_SUCCESS_NOTIFICATION',
    /**
     * @value Share in a post
     * @description Option to share an event via a post in the current community
     */
    SHARE_IN_POST = 'EVENTS.SHARE_IN_POST',
    /**
     * @value Unanswered
     */
    UNANSWERED = 'EVENTS.EVENT_BUTTON.UNANSWERED',
    /**
     * @value Unregister
     * @description This translation appears when hover the register button in "Registered" state
     */
    UNREGISTER = 'FRONT.EVENT_BUTTON.UNREGISTER',
    /**
     * @value Please insert a valid number.
     */
    VALID_NUMBER_ERROR = 'EVENTS.VALID_NUMBER_ERROR',
    /**
     * @value Join the event
     */
    VIDEO_CONFERENCE_LABEL = 'FRONT.EVENT.DIALOG.VIDEO_CONFERENCE_LABEL',
    /**
     * @value Waiting list
     */
    WAITING_LIST = 'EVENTS.WAITING_LIST',
}
